import React from "react";
import DynamicTable from "../../../../../components/reusable/DynamicTable";
import StatusBadge from "../../../../../utils/StatusBadge";


const departmentColumns = [
    { key: "__sn", label: "#" },
    { key: "name", label: "Department", sortable: true },
    { key: "code", label: "Code", sortable: true },
    { key: "office", label: "Office", sortable: true },
    { key: "employees", label: "Employees", sortable: true },
    { key: "activeTasks", label: "Active Tasks", sortable: true },

    {
        key: "completionRate", label: "Task Completion", sortable: true,
        render: (value) => value != null ? `${value}%` : "—",
    },
    {
        key: "status", label: "Status",
        render: (value) => (<StatusBadge status={value} />),
    },
];


const DepartmentsTable = ({ departments, loading, onView }) => {
    const actions = [
        {
            label: "View",
            title: "View Department",
            onClick: onView,
        },
    ];

    if (loading) {
        return (
            <div
                style={{
                    padding: "40px",
                    textAlign: "center",
                    color: "#64748b",
                }}
            >
                Loading departments...
            </div>
        );
    }

    return (
        <DynamicTable
            columns={departmentColumns}
            data={departments}
            onAction={actions}
        />
    );
};

export default DepartmentsTable;
